import * as titleProductStyles from '../../styles/internal-page/title-product.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import Category from './filter/Category';
import { navigate } from 'gatsby-link';


const TitleProduct = React.memo(function TitleProduct ({
  label, subtitle, contents
}) {

  return (
    <div
      className={titleProductStyles.rootTitle}
    >
      <h1 className={titleProductStyles.title}>
        {label}
      </h1>
      <div className={titleProductStyles.dividerContent}>
        <div className={titleProductStyles.dividerContentItem}>
          <div
            className={titleProductStyles.horizontalBar}
          >
          </div>
        </div>
      </div>
      {subtitle &&
        <div className={titleProductStyles.subtitleContent}>
          <p
            className={titleProductStyles.subtitle}
          >
            {subtitle.replace(/(<([^>]+)>)/ig, '')}
          </p>
        </div>
      }
      {contents.length !== 0 &&
        <div className={titleProductStyles.actionRoot}>
          {contents.map((content, index) => {
            return (
              <Category
                ariaDescribedBy={content.label}
                ariaLabel={content.label}
                handleClick={() => {
                  navigate('../');
                }}
                key={index}
                label={content.label}
                notFocusable
                variant="contained"
              />
            );
          })}
        </div>
      }
    </div>
  );
});

TitleProduct.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  })).isRequired,
  label: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default TitleProduct;
